/* eslint-disable no-unused-vars */
import request, { requestAuth, requestFile } from '@/utils/request'
import type {
    IAddOnlineReviewData,
    IAddRelevant,
    IDictatorship,
    IListRes,
    IOnlineReviewDataRes,
    IOnlineReviewQuery,
    IRelevant,
    IReviewResult
} from '@/store/models/process.model'
import { IBu } from '@/store/models/auth.model'
import { RoleCont } from '@/store/constant/auth.constant'

export interface IQueryParam {
    pageNo?: number
    pageIndex?: number
    pageSize: number
    classification?: string | undefined
    platform?: string | undefined
}

// process progress
export const uploadFile = (data: FormData, fileType?: string): Promise<{
    id: number
    fileName: string
    fullPath: string
}[]> => request({
    method: 'POST',
    url: '/api/zuul/pangooITMT/onlineReview/files',
    params: {
        fileType
    },
    data
})

// 导出评审信息excel
export const exportReviewInfoExcel = (reviewTab: number): Promise<{
    data: any
    type: string
    suffix: string
}> => requestFile({
    method: 'GET',
    url: '/api/pangooITMT/onlineReview/reviewList/export',
    responseType: 'blob',
    params: {
        reviewTab
    }
})
export const getFile = (fileId: number): Promise<{
    data: any
    type: string
    suffix: string
    fileName: string
}> => requestFile({
    method: 'GET',
    url: `/api/pangooITMT/onlineReview/file/${fileId}`,
})
export const getFileList = (fileType: string): Promise<IListRes> => request<IListRes>({
    method: 'GET',
    url: '/api/pangooITMT/onlineReview/file/list',
    params: {
        fileType
    }
})




export const delFile = (fileId: number): Promise<any> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/onlineReview/file/${fileId}`,
})
// 获取工作组分类项目信息列表
export const getOnlineReview = (params: IOnlineReviewQuery): Promise<IListRes> => request({
    method: 'GET',
    url: '/api/pangooITMT/onlineReview',
    params
})

// 根据id删除
export const delOnlineReview = (id: number): Promise<any> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/onlineReview/delete/${id}`,
})

export const getOnlineReviewById = (id: number): Promise<IOnlineReviewDataRes> => request({
    method: 'GET',
    url: `/api/pangooITMT/onlineReview/${id}`,
})
// 添加申请
export const addOnlineReview = (data: IAddOnlineReviewData): Promise<IListRes> => request({
    method: 'POST',
    url: '/api/pangooITMT/onlineReview',
    data
})
export const editOnlineReview = (params: IAddOnlineReviewData & { id: number }): Promise<IListRes> => request({
    method: 'PUT',
    url: `/api/pangooITMT/onlineReview/${params.id}`,
    data: params
})

export const relevantTechProj = (data: any[]): Promise<any[]> => request({
    method: 'POST',
    url: '/api/pangooITMT/techProjectInfo/saveRelatedTechProj',
    data
})

// 提案申请相关性反馈
export const relevant = (data: IRelevant, isAdmin: boolean): Promise<IListRes> => request({
    method: 'POST',
    url: '/api/pangooITMT/onlineReview/relevant?isAdmin=' + isAdmin,
    data
})
// 根据id获取申请反馈信息 (ITMT反馈列表)
export const relevantGetById = (id: number): Promise<any[]> => request({
    method: 'GET',
    url: `/api/pangooITMT/onlineReview/relevant/${id}`,
})
// TMT反馈列表
export const getOnlineReviewTMT = (id: number): Promise<any[]> => request({
    method: 'GET',
    url: `/api/pangooITMT/onlineReview/review/${id}`,
})
// 一键催办
export const postOneClickUrge = (data: {
    reviewId: number,
    userList: string[]
}): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/onlineReview/sendMsg',
    data,
})
// 更新TMT审核状态
export const updateOpenViewStatus = (id: number): Promise<any[]> => request({
    method: 'POST',
    url: `/api/pangooITMT/onlineReview/review/openView/${id}`,
})
// 导致评审列表Excel
export const exportReviewExcel = (params?: { type: number }): Promise<{
    data: any
    type: string
    suffix: string
}> => requestFile({
    method: 'GET',
    url: '/api/pangooITMT/onlineReview/review/export',
    responseType: 'blob',
    params
})
export const exportContributionExcel = (params?: { reviewType: number }): Promise<{
    data: any
    type: string
    suffix: string
}> => requestFile({
    method: 'GET',
    url: '/api/pangooITMT/onlineReview/contribution/export',
    responseType: 'blob',
    params
})

// 添加TMT反馈
export const addOnlineReviewTMT = (params: IAddRelevant): Promise<IListRes> => request({
    method: 'POST',
    url: '/api/pangooITMT/onlineReview/review/tmt',
    data: params
})
// 获取反馈结果信息
export const getOnlineReviewResult = (id: number): Promise<IReviewResult> => request({
    method: 'GET',
    url: `/api/pangooITMT/onlineReview/reviewResult/${id}`,
})
// 获取反馈结果信息
export const itmtDictatorship = (data: IDictatorship): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/onlineReview/review/itmt',
    data
})
// 获取多少个工作日后的日期
export const getWorkDateDiff = (params: {
    startDay: string
    diffDay: number
}): Promise<any> => requestAuth({
    method: 'GET',
    url: '/api/pangooAuth/auth/workDay/diff',
    params
})
// 获取BU/CT清单
export const getBUList = (): Promise<IBu[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/bu'
})
// 选择参会、旁听人员
export const selectReviewPenson = (data: {
    idList: number[]
    reviewId: number
}): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/onlineReview/review/attend',
    data
})
// 获取当前登录人员信息
export const getUserWorkGroup = (params: {
    login: string
    orgRole: RoleCont
}): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/orgChart/org/check',
    params
})

// 根据角色获取组织下的人员信息
export const getOrgRoleUsers = (params: {
    orgRole: RoleCont
}): Promise<any> => request({
    method: 'get',
    url: `/api/pangooITMT/orgChart/org/${params.orgRole}/info`,
    params
})

// 获取当前登录人员信息
export const getWorkgroupLeader = (params: {
    workGroupId: number
    orgRole: RoleCont
}): Promise<any> => request({
    method: 'get',
    url: `/api/pangooITMT/orgChart/org/${params.workGroupId}/${params.orgRole}`
})
// 获取历史评审记录
export const getReviewHistory = (params: {
    ptn?: string
    reviewType: number
    techId?: string
}): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/onlineReview/review/history',
    params
})

// BU列表管理
export const addBU = (data: {
    bu: string
    divName: string
}): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/bu',
    data
})
export const modifyBU = (data: {
    id: string
    bu: string
    divName: string
}): Promise<any> => request({
    method: 'put',
    url: `/api/pangooITMT/bu/${data.id}`,
    data
})
export const delBU = (id: string): Promise<any> => request({
    method: 'delete',
    url: `/api/pangooITMT/bu/${id}`,
})

// 项目平台BU信息管理
export const getProdList = (params: IQueryParam): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/project/bu',
    params
})
export const addProd = (data: {
    bu: string
    divName: string
}): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/project/bu',
    data
})
export const modifyProd = (data: {
    id: string
    bu: string
    divName: string
}): Promise<any> => request({
    method: 'put',
    url: `/api/pangooITMT/project/bu/${data.id}`,
    data
})
export const delProd = (id: string): Promise<any> => request({
    method: 'delete',
    url: `/api/pangooITMT/project/bu/${id}`,
})
// TMT专家评审榜单
export const expertReviewList = (): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/onlineReview/review/expertReviewList',
})
// 核心关键技术数量
export const getCoreList = (params: {
    startYear: number
    endYear: number
}): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/statistics/getCoreList',
    params
})
// 近12个月完成开发的技术数量
export const getCompleteTechList = (params: {
    startYearQuarter: string
    endYearQuarter: string
}): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/statistics/getCompleteTechList',
    params
})
// 技术评审月度推移图
export const monthlyProgressChart = (params: {
    reviewType?: number
    year: number
}): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/onlineReview/review/monthlyProgressChart',
    params
})
// 技术评审月度推移图
export const getLeaderForWorkgroup = (): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/orgChart/org/workgroup',
})

export enum EAPI_TYPE {
    TECH_TYPE = 0, //技术类型
    LEAD = 1, //先进性
}



interface IChartParams {
    'endTime': string,
    'isPlReview': boolean | null,
    'name': string,
    'reviewType': number,
    'startTime': string,
    'type'?: EAPI_TYPE | ESTACKED_CHART_TYPE,
}

// 获取图表数据
export const getChartDataApi = (params: IChartParams): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/onlineReview/getWorkGroupTechDistribution?t=' + Math.random(),
    data: params
})

// 获取图表数据
export const getChart3DataApi = (params: IChartParams): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/onlineReview/getWorkGroupDistribution?t=' + Math.random(),
    data: params
})

// 获取图表数据
export const getChart45DataApi = (params: IChartParams): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/onlineReview/getTechLeadershipDistribution?t=' + Math.random(),
    data: params
})


export enum ESTACKED_CHART_TYPE {
    CHART6 = 1,
    CHART7 = 2,
    CHART8 = 3,
}
// 获取图表数据
export const getChart678DataApi = (params: IChartParams): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/onlineReview/getTechDivDistribution?t=' + Math.random(),
    data: params
})

// 获取历史记录
export const getReviewLog = (params: {
    id: string
    pageNo: string
    pageSize: string
}): Promise<any> => request({
    method: 'get',
    url: '/api/pangooITMT/log',
    params: {
        ...params,
        table: 'tech_online_review'
    }
})


// 管理员修改评审结果
export const updateReviewResult = (data: {
    id: string
    reviewResult: boolean | null
}): Promise<any> => request({
    method: 'put',
    url: '/api/pangooITMT/onlineReview/updateReviewResult/' + data.id,
    data: {
        reviewResult: data.reviewResult
    }
})

export const postAISearch = (data: {
    keyWord: string
    filePath:string
}): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/onlineReview/aiSearch',
    data,
})

export const uploadAISearchFile = (data:FormData): Promise<any> => request({
    method: 'post',
    url: '/api/pangooITMT/onlineReview/uploadAiSearchFile',
    data,
})

